import { formatDateString } from "./format-date-string";
export var eventDateRange = function (startDate, endDate) {
  var startDateFull = formatDateString(startDate, 'YYYY-MM-DD');
  var endDateFull = formatDateString(endDate, 'YYYY-MM-DD');
  var startMonth = formatDateString(startDate, 'MM');
  var endMonth = formatDateString(endDate, 'MM');
  var startYear = formatDateString(startDate, 'YYYY');
  var endYear = formatDateString(endDate, 'YYYY');
  var startFormat = 'D';
  if (startDateFull === endDateFull) {
    return formatDateString(startDate, 'D MMMM YYYY');
  }
  if (startMonth !== endMonth) {
    startFormat = 'D MMM';
  }
  if (startYear !== endYear) {
    startFormat = 'D MMM YY';
  }
  return startDate && endDate && "".concat(formatDateString(startDate, startFormat), "\u2013").concat(formatDateString(endDate, 'D MMMM YYYY'));
};